'use client'

// Комментарий на русском: регистрируем один SW для PWA + push сразу при старте приложения,
// чтобы сайт был "устанавливаемым" как приложение даже без включения уведомлений.
import { useEffect } from 'react'

export default function PwaServiceWorker() {
  useEffect(() => {
    // Комментарий на русском: в dev не регистрируем SW, чтобы не ловить кеш/обновления между сборками.
    if (process.env.NODE_ENV !== 'production') return
    if (!('serviceWorker' in navigator)) return

    // Комментарий на русском: привязываем SW к build-id, чтобы при каждом деплое SW гарантированно обновлялся,
    // а кэши можно было версионировать без ручных правок.
    const buildId = String(process.env.NEXT_PUBLIC_APP_BUILD_ID || '').trim()
    // Комментарий на русском: отдельный build-id для API — чтобы можно было сбрасывать API-кэш без сброса shell/pages/asset кэшей.
    const apiBuildId = String(process.env.NEXT_PUBLIC_API_BUILD_ID || '').trim()
    const qs = [buildId ? `v=${encodeURIComponent(buildId)}` : '', apiBuildId ? `api=${encodeURIComponent(apiBuildId)}` : '']
      .filter(Boolean)
      .join('&')
    const swUrl = qs ? `/push-sw.js?${qs}` : '/push-sw.js'
    navigator.serviceWorker
      .register(swUrl, { scope: '/', updateViaCache: 'none' })
      .then((reg) => reg.update().catch(() => {}))
      .catch(() => {})
  }, [])

  return null
}


